import { ExclamationCircleFilled } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import FileUpload from './dataSourcesCreateSteps/fileUpload';
import PropTypes from 'prop-types';
import React from 'react';

const EmptyData = props => {
  const { postNewFile } = props;
  return (
    <div id="no-sample-data">
      <h2>
        <ExclamationCircleFilled /> No sample data found for this data source.
      </h2>
      <FileUpload postNewFile={postNewFile} includeMarginTop />
    </div>
  );
};

EmptyData.propTypes = {
  postNewFile: PropTypes.func.isRequired,
};

export default withRouter(EmptyData);
